<template>
  <tabs parent="servers">
    <tab
      id="all"
      :name="translate('server.list')"
      :href="url+'/all'"
    >
      <list-server
        :servers="servers"
        :active="active"
        :groups_servers="groups_servers"
        @update_servers_list="get_servers"
        @change_active="change_active"
      />
    </tab>
    <tab
      v-if="this.$store.getters.getPermissions.permissionGod"
      id="group"
      :name="translate('server.groups')"
      :href="url+'/group'"
    >
      <server-group
        :groups_servers="groups_servers"
        @update_servers_group="get_servers"
      />
    </tab>
  </tabs>
</template>

<script>
import ServerGroup from './Servers/ServerGroup'
import ListServer from './Servers/List'

import {Tabs, Tab} from 'components/UIComponents/Tabs'

export default {
  name: 'Servers',
  components: {
    Tabs,
    Tab,
    ServerGroup,
    ListServer
  },
  data () {
    return {
      active: false,
      servers: [],
      loading: true,
      groups_servers: []
    }
  },

  computed: {
    url () { return '/servers' }
  },

  watch:{
    active(){
      this.loading = true
      this.get_servers()
    }
  },

  created() {
    this.get_servers()
  },

  methods: {
    async get_servers(){
      let val = {
        active: this.active
      }
       await this.$http.v1.getServers(val, (response) => {
        this.servers = response.data.servers.sort((a, b) => { return b['device_count'] - a['device_count'] })
        this.groups_servers = response.data.server_groups
        this.loading = false
      })
    },
    change_active(val){
      this.active = val
    }

  },

}
</script>
